export enum StreamingState {
	CLOSED_ON_AFK_ERROR = "closedOnAfkError",
	INITIALIZING_STREAMING = "initializingStreaming",
	LOADING_SCENE = "loadingScene",
	READY_TO_INIT = "readyToInit",
	SCENE_LOADED = "sceneLoaded",
	VIDEO_INITIALIZED = "videoInitialized",
	LOADING = "loading",
	WELCOME = "welcome",
}

export const BMS_STAGE_ORG_ID = "654cdfaa8f24c000d918d372";
export const BMS_ORG_ID = "664db3a67a2ac29487b4c768";
export const BMS_TEST_ORG_ID = "5c4868857922384fb456af48";

/** Our own HEGIAS organization. */
export const HEGIAS_ORG_ID = "5d2da13d7b9edb31c883fca8";

export const WEBSOCKET_EVENT_CODE_NO_STATUS = 1005;
/** Normal closure — what the SDK sends for a disconnect or forced reconnect we asked for. */
export const WEBSOCKET_EVENT_CODE_NORMAL = 1000;
